import React, { FC, ReactElement } from "react";
import { MdAccountCircle } from "react-icons/md";
import { Link } from "react-router-dom";
import { API_GetUsersDetails } from "../../actions";

type UserMenuProps = {
  user: API_GetUsersDetails;
  Logout: Function;
  close: Function;
};

const UserMenu: FC<UserMenuProps> = ({ user, Logout, close }): ReactElement => {
  return (
    <div
      className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
      role="menu"
      aria-orientation="vertical"
      aria-labelledby="user-menu-button"
      tabIndex={-1}
    >
      <div className="px-2 text-center">
        <MdAccountCircle className="text-7xl mx-auto mt-2 text-green-900" />
        <h2
          className="font-bold text-xl text-green-900"
          title={user.phone_number}
        >
          {user.fname}
        </h2>
        <div
          title={user.email}
          className="text-gray-600 overflow-x-hidden text-sm"
        >
          {user.email}
        </div>
      </div>
      <div className="p-2 text-center">
        <Link
          to="/profile"
          className="p-1 block sm:block border-b-300 w-full text-green-700 hover:text-white hover:bg-green-700 bg-green-100 rounded mb-1"
        >
          View profile
        </Link>
        <button
          onClick={() => {
            Logout();
            close();
          }}
          className="p-1 block sm:block border-b-300 w-full text-red-700 hover:text-red-700 hover:bg-red-200 bg-red-100 rounded mb-1"
        >
          Sign out
        </button>
      </div>
    </div>
  );
};
export default UserMenu;
